import ComponentBase from 'components/_base/ComponentBase';
import Handlebars from 'handlebars-template-loader/runtime';
import jQuery from 'jquery';
import JPRouteHelper from '../../helpers/JPRouteHelper';

const JPList = ComponentBase.extend({

    template: require('./jpList.hbs'),
    componentClass: 'directions-box-jp-list-route',

    events: {
        'click .jp-list-element': 'onClickRouteElement',
        'click .view-details-cta': 'onClickViewDetails',
        'click .view-map-cta': 'onClickViewMap'
    },

    routeSelectedIndex: 0,

    stepsShownPerRoute: 2,

    isDetailsPanelOpened: false,

    initialize(config) {
        this.bus = this.widget.bus;
        this.loadHelpers();
        ComponentBase.prototype.initialize.call(this, config);
    },

    updateRoute(route, handleRoutes) {
        this.routes = route.routes;
        this.handleRoutes = handleRoutes;
        this.routeSelectedIndex = 0;
        this.isDetailsPanelOpened = false;
        this.travelMode = route.request.travelMode.toLowerCase();
        if (this.routes.length) {
            let normalizeRoutes = [];
            this.routes.forEach(route => {
                if (this.isTransitRoute(route)) {
                    normalizeRoutes.push(this.normalizeTransitRoute(route));
                } else {
                    normalizeRoutes.push(this.normalizeNonTransitRoute(route));
                }
            });
            this._bindListeners(handleRoutes);
            this.templateConfig = {
                stepsShownPerRoute: this.stepsShownPerRoute,
                normalizeRoutes: normalizeRoutes,
                selectedRouteIndex: this.selectedRouteIndex
            };
        } else {
            this.templateConfig = {
                noResults: true
            }
        }
        this.show();
        this.$el.replaceWith(this.render().$el);
    },

    _bindListeners(handleRoutes) {
        handleRoutes.routesView.forEach(routeView => {
            const routeModel = routeView.routeModel;
            routeModel.on('change:selected', (model) => {
                if (model.isSelected()) {
                    this.selectRoute(routeView);
                    if (this.isDetailsPanelOpened) {
                        this.triggerDetailsPanel();
                    }
                }
            });

        });
    },

    selectRoute(route) {
        this._removeSelectedClassInCurrentRoute();
        this.routeSelectedIndex = route.index;
        this._addSelectedClassInRoute();
    },

    normalizeNonTransitRoute(route) {
        const legs = route.legs[0];
        return {
            icon: this.isWalkingRoute(route) ? 'walking' : this.travelMode,
            via: `${route.summary}`,
            time: legs.duration.text,
            distance: legs.distance.text
        };
    },

    normalizeTransitRoute(route) {
        const legs = route.legs[0];
        let totalWalking = 0;
        legs.steps.forEach(step => {
            if (step.travel_mode === 'WALKING') {
                totalWalking += step.duration.value;
            }
        });
        return {
            icon: this.travelMode,
            departureTime: legs.departure_time ? legs.departure_time.text : '',
            arrivalTime: legs.arrival_time ? legs.arrival_time.text : '',
            time: legs.duration.text,
            walkingTime: (totalWalking / 60).toFixed(0),
            steps: legs.steps.map((step) => {
                if (step.travel_mode === 'WALKING') {
                    return {
                        travelMode: step.travel_mode.toLowerCase()
                    }
                } else {
                    return {
                        travelMode: step.travel_mode.toLowerCase(),
                        lineName: step.transit.line.short_name,
                        icon: step.transit.line.vehicle.local_icon,
                        color: step.transit.line.color
                    }
                }
            })
        };
    },

    onClickRouteElement(event) {
        const indexRoute = jQuery(event.currentTarget).data('route-index');
        this._selectedRouteLayerModel(indexRoute);
    },

    _removeSelectedClassInCurrentRoute() {
        const lastRouteSelectedDomElement = this.$el.find(`#jp-list-element-${this.routeSelectedIndex}`);
        lastRouteSelectedDomElement.removeClass('route-selected');
    },

    _addSelectedClassInRoute() {
        const newRouteSelected = this.$el.find(`#jp-list-element-${this.routeSelectedIndex}`);
        newRouteSelected.addClass('route-selected');
    },

    _selectedRouteLayerModel(index) {
        this.handleRoutes.routesView[index].routeModel.onSelect();
    },

    loadHelpers() {
        Handlebars.registerHelper('printStep', function() {
            return JPRouteHelper.printStep(arguments);
        });

        Handlebars.registerHelper('printDots', function() {
            return JPRouteHelper.printDots(arguments);
        });

    },

    onClickViewDetails() {
        this.triggerDetailsPanel(false);
    },

    onClickViewMap() {
        this.triggerDetailsPanel(true);
    },

    triggerDetailsPanel(collapsed) {
        this.isDetailsPanelOpened = true;
        this.bus.trigger('CLICK_IN_DETAILS_ROUTE_BTN', {
            route: this.routes[this.routeSelectedIndex],
            origin: this.parentComponent.getOriginText(),
            destination: this.parentComponent.getDestinationText(),
            travelMode: this.travelMode,
            originIsMainHotel: this.parentComponent.getOriginIsMainHotel(),
            panelCollapsed: collapsed
        });
    },

    setIsDetailsPanelOpened(isDetailsPanelOpened) {
        this.isDetailsPanelOpened = isDetailsPanelOpened;
    },

    isTransitRoute(route) {
        return route.legs[0].steps.some(step =>
            step.travel_mode === 'TRANSIT'
        );
    },

    isWalkingRoute(route) {
        return route.legs[0].steps.every(step =>
            step.travel_mode === 'WALKING'
        );
    }
});

export default JPList;



// WEBPACK FOOTER //
// ./src/components/JPList/JPList.js